function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M174.6 676.7h-41.5V167.8h535v38c0 19.3 15.7 35 35 35s35-15.7 35-35v-73c0-19.3-15.7-35-35-35h-605c-19.3 0-35 15.7-35 35v578.9c0 19.3 15.7 35 35 35h76.5c19.3 0 35-15.7 35-35s-15.6-35-35-35z"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M560.9 856.2H303V347.3h535v156.4c0 19.3 15.7 35 35 35s35-15.7 35-35V312.3c0-19.3-15.7-35-35-35H268c-19.3 0-35 15.7-35 35v578.9c0 19.3 15.7 35 35 35h292.8c19.3 0 35-15.7 35-35s-15.6-35-34.9-35z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M753.9 454.4c0-19.3-15.7-35-35-35H423.3c-19.3 0-35 15.7-35 35s15.7 35 35 35H719c19.3 0 34.9-15.6 34.9-35zM583.1 598.5c0-19.3-15.7-35-35-35H423.3c-19.3 0-35 15.7-35 35s15.7 35 35 35h124.8c19.3 0 35-15.7 35-35zM423.3 707.6c-19.3 0-35 15.7-35 35s15.7 35 35 35h59.4c19.3 0 35-15.7 35-35s-15.7-35-35-35h-59.4zM971.9 609.2c-13.7-13.7-35.8-13.7-49.5 0l-179 179-92.3-92.3c-13.7-13.7-35.8-13.7-49.5 0-13.7 13.7-13.7 35.8 0 49.5l117.1 117.1c6.6 6.6 15.5 10.3 24.7 10.3s18.2-3.7 24.7-10.3l203.7-203.7c13.7-13.7 13.7-35.9 0.1-49.6z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      "width": "1em",
      "height": "1em",
      "verticalAlign": "middle",
      "fill": "currentColor",
      "overflow": "hidden"
    },
    viewBox: "0 0 1024 1024",
    version: 1.1
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/batch.bf2965f5.svg";
export { SvgComponent as ReactComponent };